import React from "react";
import TextMedium from "../TextComponent/TextMedium";
import { useSelector } from "react-redux";

export default function CardLevelProgress ({title,level}) {
    const LoginCompleteReducer = useSelector(state => state.ipcurrent);
    const someStyle = {
        "--width": `${(level).toFixed(2)}%`,
        "--level": (level).toFixed(2) >= 10 ? `${(level).toFixed(2)/2}%`:`10%`
    }

    const someStyleTwo = {
        "--width": '50%',
        "--level": '50%'
    }

    const someStyleThree = {
        "--width": '0%',
        "--level": '0%'
    }

    return (
            <div className="manager-container__level-service">
                <div className="manager-container__level-service__title">
                    <TextMedium text={title} color="gray" />
                </div>
                <div className="manager-container__level-service__progress" datacustom>
                    {LoginCompleteReducer.isLoginComplete ?
                    level !== 0 ?
                    <div className="progress-bar" style={someStyle}>
                        <div className="progress-bar__title">
                            <TextMedium text={`${(level).toFixed(2)}%`} color="white" />
                        </div>
                    </div> : (
                    <div className="progress-bar-two" style={someStyleThree}></div>
                    )
                    :(
                        <div className="progress-bar-two" style={someStyleTwo}></div>
                    )}
                </div>
            </div>
    );
}